module.exports = __webpack_public_path__ + "static/BlackMinimalistMarketingProposal(3)_optimized-27b6ca9e1c1a2bf3c4e78e60727edc4a.png";